/**
 * Globaal wijzigingslogboek (actor-attributie fase 3) — leeslaag op
 * GET /api/audit/logboek.
 */
import { supabase } from './supabase';

export interface LogboekEntry {
  id: string;
  createdAt: string;
  channel: string;
  action: string;
  status: string;
  actorEmail: string;
  onBehalfOf: string | null;
  sessionRef: string | null;
  samenvatting: string | null;
  orderId: string | null;
  orderNumber: string | null;
  accountId: string | null;
  parentType: string | null;
  parentId: string | null;
  errorCode: string | null;
  errorMessage: string | null;
}

export interface LogboekFilters {
  channel?: string;
  action?: string;
  actor?: string;
  status?: string;
  order?: string;
  dagen?: number;
  limit?: number;
  offset?: number;
}

export interface LogboekResult {
  entries: LogboekEntry[];
  total: number;
  limit: number;
  offset: number;
}

async function authHeaders(): Promise<Record<string, string>> {
  const { data: { session } } = await supabase.auth.getSession();
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`;
  return headers;
}

export async function fetchLogboek(filters: LogboekFilters = {}): Promise<LogboekResult> {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v !== undefined && v !== null && `${v}`.trim() !== '') params.set(k, `${v}`);
  }
  const headers = await authHeaders();
  const response = await fetch(`/api/audit/logboek?${params.toString()}`, { headers });
  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Logboek laden mislukt' }));
    throw new Error(err.error || 'Logboek laden mislukt');
  }
  return (await response.json()) as LogboekResult;
}
